<template>
  <div class="arrival-times-container">
    <div
      v-for="(route, index) in arrivalTimes"
      :key="route.id"
      :class="[
        'route-box',
        {
          'first-box': index === 0,
          'last-box': index === arrivalTimes.length - 1,
        },
      ]"
    >
      <div class="shadow rounded-pill d-flex align-items-center justify-content-between route-element">
        <!-- Informações da Rota (Esquerda) -->
        <div class="d-flex align-items-center flex-grow-1">
          <span class="route-badge roboto-bold" :style="getColorStyle(route.routeNumber)">
            {{ route.routeNumber }}
          </span>
          <span class="route-name roboto-bold">{{ route.destinationName }}</span>
        </div>
        <!-- Container para Alerta e Tempo de Chegada -->
        <div class="d-flex align-items-center">
          <img src="@/assets/markerIcons/alert_icon.png" alt="Alerta" class="text-danger alert-container" v-show="route.hasAlert" />
          <p class="arrival-time mb-0 roboto-bold">{{ route.estimatedArrivalTimeLeft }} min.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { debugMode } from '@/config/config.js';
export default {
  inject: ['logDebug'],
  props: {
    busstopnumber: {
      type: String,
      required: true,
    },
    routeColors: {
      type: Object,
      required: true,
    },
    arrivalTimes: {
      type: Array,
      default: () => [],
    },
    busStopDetails: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      errorMessage: '',
      isLoading: true,
      refreshInterval: null,
      busStopId: '',
      busStopName: '',
      busStopLongitude: '',
      busStopLatitude: '',
      isLoadingBusStopDetails: true,
      busStopDetailsError: '',
    };
  },

  computed: {
    visibleArrivalTimes() {
      return this.arrivalTimes;
    },

    routeColorsReady() {
      return this.routeColors && Object.keys(this.routeColors).length > 0;
    },
  },

  async mounted() {
    if (debugMode) console.log('Bus Stop Number:', this.busstopnumber);
    this.logDebug('ArrivalTimesAlternative mounted, Bus Stop Number: ' + this.busstopnumber);
  },

  beforeUnmount() {},

  methods: {
    getColorStyle(routeNumber) {
      if (!this.routeColors || Object.keys(this.routeColors).length === 0) {
        console.warn('routeColors no arrivaltimesalternative não está pronto ou está vazio.');
        this.logDebug('routeColors no arrivaltimesalternative não está pronto ou está vazio.');
        return {};
      }
      const color = this.routeColors[routeNumber];
      if (!color) return {};

      const textColor = color.toLowerCase() === '#ffffff' ? '#000000' : '#ffffff';

      return {
        backgroundColor: color,
        color: textColor,
      };
    },
  },
  watch: {
    routeColors: {
      handler(newVal) {
        if (newVal || Object.keys(newVal).length > 0) {
          if (debugMode) console.log('routeColors actualizado no componente filho arrivaltimesalternative:', newVal);
          this.logDebug('routeColors actualizado no componente filho arrivaltimesalternative: ' + JSON.stringify(newVal));
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
/* ==================================================
   Container — 960 x 864px
   Padding lateral de 48px para as margens das caixas
   ================================================== */
.arrival-times-container {
  width: 960px;
  height: 864px;
  padding-left: 48px;
  padding-right: 48px;
  padding-top: 10px;
  padding-bottom: 0;
  overflow: hidden;
}

/* ==================================================
   Caixa de cada rota
   - 81px de altura, 864px de largura, 27px de espaço entre elas
   ================================================== */
.route-box {
  width: 864px;
  height: 81px;
  margin: 0;
  margin-bottom: 27px;
  display: flex;
  align-items: center;
}

.route-box.last-box {
  margin-bottom: 0;
}

.route-element {
  width: 864px;
  height: 81px;
  background-color: #f1f2f2;
  margin: 0;
  padding-left: 13px;
  padding-right: 32px;
}

.route-badge {
  font-size: 40px;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  width: 100px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  flex-shrink: 0;
  /* padding: 0 20px; */
}

.route-name {
  font-size: 30px;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  margin-left: 24px;
  margin-right: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.arrival-time {
  font-size: 30px;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  text-align: right;
  white-space: nowrap;
  margin-left: 16px;
}

.text-danger {
  height: 40px;
}

.alert-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.1rem;
  flex-shrink: 0;
}
</style>
